import React from 'react'
import Modal from 'react-responsive-modal'


const DeleteBranch = ({ id, setId, deleteBranch }) => {
    console.log(id, deleteBranch)
    return (
        <Modal open={id} onClose={() => setId(null)} center >
            <div className='bg-white p-6 rounded-lg w-full max-w-lg h-[200px]'>
                <div className="flex justify-center items-center">
                    <h2 className="pt-[20px] font-medium text-[#27004a] text-[18px] text-center">Are you sure want to delete this Branch</h2>
                </div>
                <div className="flex justify-around items-center gap-2 mt-[27px] p-[10px]">
                    <button onClick={() => deleteBranch(id)} className="bg-[#27004a] px-4 py-2 rounded-md text-white">Yes , Confirm</button>
                    <button className="bg-[#27004a] px-4 py-2 rounded-md text-white" onClick={() => setId(null)}>No , Cancel</button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteBranch